<template>
  <div class="tooltip">
    <question-circle-icon :color="color"></question-circle-icon>
    <div><slot></slot></div>
  </div>
</template>

<script>
import QuestionCircleIcon from '~/components/Common/Svg/QuestionCircleIcon';
export default {
  components: { QuestionCircleIcon },
  props: {
    color: {
      type: String,
      default: '#949BAD', // gray-400
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Tooltip.scss';
</style>
